import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/models-and-costs/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/models-and-costs/')({
  component: Page,
});
